import _ from "lodash";

/***EachpureJSfunctionmightbeusedasalambdatermwhich*actsonlywhenargumentisanExternalobject.**Let`f`beapureJSfunctiongivenbyastring.*`newExternal(f,"Function",...)`isalambdatermrepresenting`f`.*Theonlyreductionruleis*```*Applicationn(External(f,"Function"),External(x))*->External(f(x))*```**Atypeofthefunctionwhichisof{@linkmodule:Types~FunctionType},
 * must be specified precisely, because
 * a type of the result is restored by its derived type.
 *
 * For example, a term
 * ```
 * Application(
 *   External(f, "Function", FunctionType("Number", "UserType")),
 *   External(10, "Number"))
 * ```
 * is reduced to `External(f(10), "UserType")`.
 * There is no generic way to figure out that `f(10)` is of type `"UserType"`
 * and not of `"Object"` nor other type,
 * but derive it from `f`'s type.
 *
 * @summary Predefined `"Function"` External object: JS Function as lambda term.
 * @member Function
 * @memberof module:EInstances
 */

import T from "../Types";
import Lambda from "../Lambda";
var C = Lambda.Constructors;

/**
 * Reduction of {@link module:EInstances~Function External Functions}.
 * @memberof module:EInstances
 * @member
 */
function ExternalFunctionReduction(term, reduce) {
  if(term instanceof C.Application &&
       term.func instanceof C.External &&
         term.func.objType == "Function" &&
           term.arg instanceof C.External) {
    var fn = term.func.object;
		if(_.isString(fn)) fn = "(" + fn + ")";
    var result = eval(fn)(term.arg.object);
    var type = T.ModusPonens(term.func.type(), term.arg.type());
    if(type == T.AnyType) {
      console.error("got AnyType");
      console.warn(term);
    }
    return new C.External(result, Lambda.getExternalObjType(type), type);
  }
}

// add to default reductions
Lambda.Reduction.DefaultReductions.push(ExternalFunctionReduction);
